import { Badge, Group, Stack, Table, Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { VlmEventObject } from '@/types/vlm'

type VlmResultObjectsTableProps = {
  objects: VlmEventObject[]
}

export const VlmResultObjectsTable = ({
  objects
}: VlmResultObjectsTableProps) => {
  if (objects.length === 0) {
    return null
  }

  return (
    <Stack gap="xs">
      <Text fw={600}>
        <FormattedMessage id="vlm.results.objects.title" />
      </Text>

      <Table
        variant="vertical"
        layout="fixed"
        verticalSpacing="sm"
        horizontalSpacing="md"
        withTableBorder
      >
        <Table.Tbody>
          {objects.map((obj) => (
            <Table.Tr key={obj.object_id}>
              <Table.Th w={200}>
                <FormattedMessage
                  id="vlm.results.objects.fields.id"
                  values={{ id: obj.object_id }}
                />
              </Table.Th>
              <Table.Td>
                <Stack gap={6}>
                  <Text size="sm">{obj.description}</Text>
                  <Group gap={4}>
                    {obj.tags.map((tag) => (
                      <Badge key={tag} size="sm" variant="light">
                        {tag}
                      </Badge>
                    ))}
                  </Group>
                </Stack>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Stack>
  )
}
